import { executeTask, executeTaskStreaming } from './aiTaskService';
import { getDownloadUrl } from './fileService';

/**
 * Bridges the file extraction UI with the AI Task execution API.
 * @param taskName The name of the AI task to execute.
 * @param fileId The ID of the file to process.
 * @param formValues Additional input values from the dynamic form.
 */
export const extractFileWithTask = async (taskName: string, fileId: string, formValues: Record<string, any> = {}) => {
    const fileUrl = await getDownloadUrl(fileId);
    return await executeTask(taskName, { file_url: fileUrl, ...formValues });
};

export const extractFileWithTaskStreaming = async (taskName: string, fileId: string, formValues: Record<string, any> = {}) => {
    const fileUrl = await getDownloadUrl(fileId);
    return executeTaskStreaming(taskName, { file_url: fileUrl, ...formValues });
};